import { css } from "../../../../styled-system/css";
import { t } from "../../../libs/i18n";
import type { PayForm } from "../use-pay-form";

type PointUsageBlockProps = {
  balances: PayForm["balances"];
};

export default function PointUsageBlock({ balances }: PointUsageBlockProps) {
  return (
    <div
      className={css({
        bg: "surface.tertiary",
        rounded: "xl",
        py: "20px",
        px: "24px",
      })}
    >
      <div
        className={css({
          fontSize: "16px",
          color: "text.primary",
          fontWeight: "600",
        })}
      >
        {t("利用ポイント")}
      </div>
      <div
        className={css({
          fontSize: "14px",
          color: "text.secondary",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          mt: "16px",
        })}
      >
        {balances.map((balance) => (
          <div
            key={balance.fundSourceId}
            className={css({
              display: "flex",
              justifyContent: "space-between",
            })}
          >
            <div
              className={css({
                fontSize: "16px",
                color: "text.primary",
              })}
            >
              {balance.fundSource?.name}
            </div>
            <div>{balance.balanceState.amount}pt</div>
          </div>
        ))}
      </div>
    </div>
  );
}
